export enum LogLevel {
  Debug = 'Debug',
  Trace = 'Trace',
  Info = 'Info',
  Comment = 'Comment',
  Warning = 'Warning',
  Error = 'Error',
  Critical = 'Critical'
}

/**
 * Specifies the curernt logs eventType
 */
export enum LogEventName {
  onJsonDocumentValidationError = 'onJsonDocumentValidationError',
  onChoiceClick = 'onChoiceClick',
  onLinkClick = 'onLinkClick',
  onComponentError = 'onComponentError',
  onContentRetrievalError = 'onContentRetrievalError',
  onDafDiagnosticsStarted = 'onDafDiagnosticsStarted',
  onDafDiagnosticsCompleted = 'onDafDiagnosticsCompleted',
  onDafDiagnosticsFailure = 'onDafDiagnosticsFailure',
  onDafDiagnosticsActionTimeout = 'onDafDiagnosticsActionTimeout',
  onDafDiagnosticsActionResultIsNull = 'onDafDiagnosticsActionResultIsNull',
  onDafParamValidationError = 'onDafParamValidationError',
  onSafDiagnosticsFailure = 'onSafDiagnosticsFailure',
  onNodeRendered = 'onNodeRendered',
  // to be used for components other than nodes
  onComponentRenderd = 'onComponentRenderd',
  onConditionEvaluationFailed = 'onConditionEvaluationFailed',
  // saf log names
  onStartDiagnosticsSucceeded = 'onStartDiagnosticsSucceeded',
  onStartDiagnosticsFailed = 'onStartDiagnosticsFailed',
  onGetDiagnosticsResultSuceeded = 'onGetDiagnosticsResultSuceeded',
  onGetDiagnosticsResultFailed = 'onGetDiagnosticsResultFailed',
  onGetDiagnosticsResultTimeout = 'onGetDiagnosticsResultTimeout',
  onGetDiagnosticsResultSuceededWithNext = 'onGetDiagnosticsResultSuceededWithNext',
  onStartDiagnosticsRun = 'onStartDiagnosticsRun',
  onDiagnosticsRerun = 'onDiagnosticsRerun',
  onDiagnosticResourceReturned = 'onDiagnosticResourceReturned',
  onDiagnosticResourceRetrivalFailure = 'onDiagnosticResourceRetrivalFailure',
  onSafDiagnosticRendered = 'onSafDiagnosticRendered',
  onSAfActionRunFailed = 'onSAfActionRunFailed',
  onSAfSchemaFetchFailed = 'onSAfSchemaFetchFailed',
  onRelatedDialogFetchFailed = 'onRelatedDialogFetchFailed',
  onRedirectNodeRendered = 'onRedirectNodeRendered',
  onRedirectNodeTargetDialogIdMissing = 'onRedirectNodeTargetDialogIdMissing',
  onRelatedDialogFetchSuccess = 'onRelatedDialogFetchSuccess',
  onReturnControlFromHostError = 'onReturnControlFromHostError'
}

export interface ILogMessage {
  [key: string]: string;
}

export enum LogMessageCodes {
  StartNodeNotFound = 'StartNodeNotFound',
  TargetNodeNotFound = 'TargetNodeNotFound',
  InternalProcessionError_NodeNotFound = 'InternalProcessionError_NodeNotFound',
  DiagnosticsActionStarted = 'DiagnosticsActionStarted',
  FailedToStartDiagnosticsAction = 'FailedToStartDiagnosticsAction',
  DiagnosticsActionFailed = 'DiagnosticsActionFailed',
  DiagnosticsActionTimeout = 'DiagnosticsActionTimeout',
  DiagnosticsActionResultResponseIsNull = 'DiagnosticsActionResultResponseIsNull',
  DiagnosticsActionResponseWithIsSuccessTrue = 'DiagnosticsActionResponseWithIsSuccessTrue',
  DiagnosticsActionResponseWithIsSuccessFalse = 'DiagnosticsActionResponseWithIsSuccessFalse',
  InternalProcessionError_ConditionEvalFailed = 'InternalProcessionError_ConditionEvalFailed',
  TargetNodeIdAndRaiseEventNameNull = 'TargetNodeIdAndRaiseEventNameNull',
  ChoiceNodeClicked = 'ChoiceNodeClicked',
  DiagnosticsResultHandlerCalledMultipleTimesOrAfterTimeout = 'DiagnosticsResultHandlerCalledMultipleTimesOrAfterTimeout',
  ContentRetrievalHandlerFailed = 'ContentRetrievalHandlerFailed',
  ContentRetrievalHandlerReturnedNullResponse = 'ContentRetrievalHandlerReturnedNullResponse'
}
